export const TEE_EXECUTIVES_TYPE = 'Executives';
export const TEE_SOCIO_TYPE = 'Socio';
export const TEE_CEO_TYPE = 'CEO';